<app-navbar  [puid]="puid"  class="p-0 navbar-css">
</app-navbar>
<div class="compare-container">   
  <!-- Header Section -->
  <div class="compare-header">
    <button class="back-button" (click)="goBack()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M8.354 1.646a.5.5 0 0 1 0 .708L3.707 7H14.5a.5.5 0 0 1 0 1H3.707l4.647 4.646a.5.5 0 0 1-.708.708l-5.5-5.5a.5.5 0 0 1 0-.708l5.5-5.5a.5.5 0 0 1 .708 0z"/>
      </svg>
      Back
    </button>
    
    <div class="header-content">
      <h1 class="page-title text-center">College Comparison</h1>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-content">
      <div class="spinner"></div>
      <h3>Loading Course Details...</h3>
      <!-- <p>Please wait while we fetch information for {{ courseIds.length }} course{{ courseIds.length > 1 ? 's' : '' }}</p> -->
      <div class="loading-progress">
        <div class="course-ids-debug" *ngIf="courseIds.length > 0">
          <small>Course IDs: {{ courseIds.join(', ') }}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-container">
    <p class="error-message">{{ errorMessage }}</p>
  </div>

  <!-- Comparison Grid -->
  <div *ngIf="!isLoading && courses.length > 0" class="comparison-grid">
    <div *ngFor="let course of courses; trackBy: trackByCourseId" class="course-card">
      <!-- Course Header -->
      <div class="course-header">
        <div class="university-info">
         
          
          <div class="university-details">
            <h3 class="university-name">{{ course.university }}</h3>
            <div class="location">
              <img *ngIf="getCountryFlag(course.country)" [src]="getCountryFlag(course.country)" [alt]="course.country + ' flag'" class="country-flag" />
              <span>{{ course.location || course.country }}</span>
            </div>
          </div>
        </div>

        <div class="card-actions">
          <!-- <button class="action-btn wishlist-btn" title="Add to wishlist">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
          </button> -->
          <button class="action-btn remove-btn" title="Remove from comparison" (click)="removeCourse(course.courseId)">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- Program Info -->
      <div class="program-section">
        <div class="program-header">
            <div>
                <span class="program-label">Program Name</span>
            </div>
            <h4 class="program-name" [title]="course.course_name">
                {{ course.course_name }}
            </h4>
        </div>
        
      </div>

      <!-- QS Ranking -->
      <div class="info-row ranking-row" >
        <span class="info-label">QS Ranking 2025</span>
        <span class="info-value ranking-value">{{ course.qs_ranking }}</span>
      </div>

      <!-- Deadline -->
      <div class="info-row">
        <span class="info-label">Deadline</span>
        <span class="info-value">{{ formatDate(course.deadline) || 'Not specified' }}</span>
      </div>

      <!-- Total Costs Section -->
      <div class="costs-section">
        <div class="cost-header">
          <span class="cost-label">Yearly Tuition Fees</span>
          <span class="cost-amount">{{ formatCurrency(course.yearly_tuition_fees, course.currency) }}</span>
        </div>
        
        <!-- <div class="cost-breakdown">
          <div class="cost-item">
            <span class="cost-item-label">Tuition Fees</span>
            <span class="cost-item-value">{{ formatCurrency(course.yearly_tuition_fees, course.currency) }}</span>
          </div>
          <div class="cost-item">
            <span class="cost-item-label">Cost of Living</span>
            <span class="cost-item-value">{{ course.cost_of_living || 'NA' }}</span>
          </div>
        </div> -->
      </div>

      <!-- Additional Details -->
      <div class="additional-details">
        <div class="detail-item" *ngIf="course.duration">
          <span class="detail-label">Duration</span>
          <span class="detail-value">{{ course.duration }}</span>
        </div>
        
        <div class="detail-item" *ngIf="course.application_fee">
          <span class="detail-label">Application Fee</span>
          <span class="detail-value">{{ formatApplicationFee(course.application_fee, course.currency) }}</span>
        </div>
        
        <div class="detail-item" *ngIf="course.scholarship_available">
          <span class="detail-label">Scholarship Available</span>
          <span class="detail-value" [ngClass]="{'text-success': course.scholarship_available === 'Yes', 'text-muted': course.scholarship_available === 'No'}">
            {{ course.scholarship_available }}
          </span>
        </div>
        
        <!-- <div class="detail-item" *ngIf="course.loan_offers">
          <span class="detail-label">Loan Offers</span>
          <span class="detail-value" [ngClass]="{'text-success': course.loan_offers === 'Yes', 'text-muted': course.loan_offers === 'No'}">
            {{ course.loan_offers }}
          </span>
        </div> -->
        <div class="detail-item" *ngIf="course.vendors && course.vendors.length > 0">

          <span class="detail-label me-2">Loan Offers</span>
          <!-- Loan providers with logos -->
          <div class="d-flex flex-wrap gap-2 mt-2 ">
            <div *ngFor="let loanProvider of course.vendors.slice(0, 4)" 
                class="d-flex align-items-center gap-2 px-2 py-1 bg-light rounded-pill border">
              
              <!-- Logo -->
              <img [src]="getLoanProviderLogo(loanProvider)" 
                  [alt]="loanProvider" 
                  class="rounded-circle object-cover"
                  style="width: 20px; height: 20px;" 
                  (error)="onLoanImageError($event)" />
              
              <!-- Provider Name -->
              <span class="font-poppins text-[#212529] fw-medium" style="font-size: 12px;">
                {{ getLoanProviderDisplayName(loanProvider) }}
              </span>
            </div>
            
            <!-- Show +X more if there are more than 4 providers -->
            <div *ngIf="course.vendors.length > 4" 
                class="d-flex align-items-center px-2 py-1 bg-secondary text-white rounded-pill">
              <span style="font-size: 12px;">+{{ course.vendors.length - 4 }} more</span>
            </div>
          </div>
        </div>

      </div>

      <!-- View Details Button -->
      <div class="card-footer">
        <button class="view-details-btn" (click)="viewCourseDetails(course)">
          View Full Details
        </button>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && courses.length === 0" class="empty-state">
    <div class="empty-content">
      <h3>No courses to compare</h3>
      <p>Please select courses from the results page to start comparing.</p>
      <button class="primary-btn" (click)="goBack()">Browse Courses</button>
    </div>
  </div>
</div>